const INTERESTING_STATUSES = new Set(['Executing', 'Failure', 'Success']);

/** @param {string | undefined} iso */
function occurredTime(iso) {
	if (!iso) return 0;
	const t = new Date(iso).getTime();
	return Number.isNaN(t) ? 0 : t;
}

/**
 * Filter to interesting statuses, dedupe by subjectType+subjectId+stage (latest OccurredAt), sort desc, cap visible count.
 * @param {Array<Record<string, unknown>>} rows
 * @param {number} [visibleMax=8]
 */
export function processActivityStripRows(rows, visibleMax = 8) {
	if (!Array.isArray(rows) || rows.length === 0) return [];

	const filtered = rows.filter((r) => r && INTERESTING_STATUSES.has(String(r.status || '')));

	/** @type {Map<string, Record<string, unknown>>} */
	const latestByKey = new Map();
	for (const r of filtered) {
		const st = String(r.subjectType ?? '');
		const sid = String(r.subjectId ?? '');
		const stage = String(r.stage ?? '');
		const key = `${st}|${sid}|${stage}`;
		const prev = latestByKey.get(key);
		if (!prev || occurredTime(r.occurredAt) > occurredTime(prev.occurredAt)) {
			latestByKey.set(key, r);
		}
	}

	return Array.from(latestByKey.values())
		.sort((a, b) => occurredTime(b.occurredAt) - occurredTime(a.occurredAt))
		.slice(0, visibleMax);
}

/**
 * @param {Record<string, unknown>} row
 */
export function formatActivityStripLine(row) {
	const who = [row.subjectType, row.subjectId].filter(Boolean).join(' ');
	const parts = [who, row.stage, row.status].filter(Boolean);
	if (row.category) parts.push(String(row.category));
	if (row.source) parts.push(String(row.source));
	return parts.join(' • ');
}
